module.exports = __webpack_public_path__ + "img/01_Erlin_Irrigation_Workstation_s.cfcd127b.png";